import { render } from "./LogCountWidget.vue?vue&type=template&id=510af6e9&scoped=true"
import script from "./LogCountWidget.vue?vue&type=script&lang=js"
export * from "./LogCountWidget.vue?vue&type=script&lang=js"

import "./LogCountWidget.vue?vue&type=style&index=0&id=510af6e9&scoped=true&lang=css"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510af6e9"]])

export default __exports__